import { useQuery } from '@tanstack/react-query';
import { getDroneData, DronesResponse } from '../api/drones-api';

export const useDrones = (projectId: string | undefined) => {
  return useQuery<DronesResponse>({
    queryKey: ['drones', projectId],
    queryFn: () => getDroneData(projectId!),
    enabled: !!projectId,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}; 